<template>
  <div>
    <TeCourseAndroidCover
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />

    <TeCommonPagenav class="hidden md:block">
      <template #courseicon>
        <FontAwesomeIcon
          :icon="faAndroid"
          class="fa-fw mr-2 size-5"
        />
      </template>
      <template #coursename>
        Androidアプリ<span class="hidden md:inline">コース</span>
      </template>
    </TeCommonPagenav>

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCommonBannerSettlement
      v-if="BannerNameForShowing === 'settlement'"
      :entry-settlement-time-limit="entrySettlementTimeLimit"
      :entry-payment-url="entryPaymentUrl"
    />

    <TeCommonBannerTimelimit
      v-if="BannerNameForShowing === 'discount'"
      :entry-discount-time-limit="entryDiscountTimeLimit"
    />

    <TeCommonBannerCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <TeCourseAbout>
      <template #title>
        Androidアプリコースについて
      </template>
      <template #discription>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          1人では続かない方のためのパーソナルメンターがつくAndroidアプリ開発コース。
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          週2回マンツーマンでのメンタリング、チャット・レビューサポートで
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          短期間でオリジナルのAndroidアプリを開発できるようになる学習プログラム。
        </p>
        <p class="co-display-10 mb-0 inline-block text-co-gray-500 md:block">
          あなたのオリジナルAndroidアプリをGoogle Playで公開することがゴールです。
        </p>
      </template>
    </TeCourseAbout>


    <TeCourseAndroidTarget />

    <TeCommonDemographics />

    <TeCourseAndroidOutput />

    <TeCourseAndroidCurriculum />

    <TeCourseAndroidWork />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-first"
    /> -->

    <!-- 挫折させないパーソナルメンターサポート -->
    <section
      id="mentor-support"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pt-20">
        <h2 class="co-heading-2-caption">
          挫折させない<span class="block md:inline">パーソナルメンターサポート</span>
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          学習時の「わからない」「続かない」を解消し、挫折をなくします。
          <br class="hidden md:block">
          実務で培った技術とノウハウで受講生一人ひとりをサポートします。
        </h3>
        <div class="flex flex-col justify-center gap-x-8 sm:px-36 lg:flex-row lg:px-0">
          <TeCommonMentorSupportMentoring />

          <TeCommonMentorSupportChatSupport />

          <TeCommonMentorSupportIssueReview />
        </div>
      </div>
      <TeCommonMentorSupportAboutFlow>
        <template #flowOriginalText>
          オリジナルアプリのリリース
        </template>
        <template #learningLead>
          パーソナルメンターとの定期的なメンタリング、チャットサポート、課題レビュー、宿題に取り組みながらオリジナルアプリを制作できるスキルを身につけます。
        </template>
        <template #originalTitle>
          オリジナルアプリのリリースまでサポート
        </template>
        <template #originalLead>
          受講目的や習得スキルに合わせて、世界で1つだけのオリジナルアプリをGoogle Playにリリースするまで徹底サポートします。
        </template>
      </TeCommonMentorSupportAboutFlow>

      <TeCommonMentorSupportMentor>
        <template #mentorImage1>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-ota.jpg"
            alt="Kazuki Ota"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName1>
          Kazuki
          <br>
          Ota
        </template>
        <template #mentorProfile1>
          システムエンジニア歴約20年、プログラミング歴約35年。プログラミングの守備範囲は、フロントエンド、サーバサイド、Android開発と広く、また、普段はシステム開発プロジェクトの管理や後輩の指導を行っています。
        </template>
        <template #mentorMessage1>
          プログラミングが出来るようになると世界が広がります！受講生様に寄り添い、楽しく学んで頂けるようサポートさせて頂きます。
        </template>
        <template #mentorImage2>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-hori.jpg"
            alt="Kazuumi Hori"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName2>
          Kazuumi
          <br>
          Hori
        </template>
        <template #mentorProfile2>
          アプリはAndroid/iOSと、WebフロントエンドからバックエンドのAPIまでフルスタックに開発を行っています。
        </template>
        <template #mentorMessage2>
          作ったものがすぐエンドユーザーに届くのがアプリ開発の醍醐味です。Androidは個人でも開発・配信しやすいプラットフォーム。楽しく良いものが作れる様に一生懸命サポートさせていただきます。
        </template>
      </TeCommonMentorSupportMentor>

      <TeCommonMentorSupportReason />
    </section>

    <TeCommonLearningCycle>
      <template #catchTwo>
        <span>アプリを</span>
        <span class="text-co-primary-500">開発する</span>
      </template>
    </TeCommonLearningCycle>

    <TeCommonSliderVoice />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-second"
    /> -->

    <TeCommonCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <section
      id="price"
      class="co-bg-striped"
    >
      <!-- 無料相談割引コード -->
      <TeCommonBannerTimeLimitCpnCode
        v-if="BannerNameForShowing === 'campaign'"
        :entry-campaign="entryCampaign"
      />

      <div class="co-container-lg px-4 py-20 xl:px-0">
        <h2 class="co-display-7 mb-[3.25rem] text-center">
          料金
        </h2>

        <TeCommonPriceTimeLimit
          v-if="BannerNameForShowing === 'discount'"
          :entry-discount-time-limit="entryDiscountTimeLimit"
        />

        <TeCoursePriceTable
          :course="course"
          :latest-cohort="latestCohort"
          :current-promotion="currentPromotion"
          :mentoring="true"
          :chat-support="true"
          :badge-sakiwari-and-campaign="true"
        >
          <template #chatSupportTime>
            24時間以内に回答
          </template>
        </TeCoursePriceTable>


        <TeCoursePriceInstallments
          :course="course"
          :installments-social="true"
        />

        <!-- 参加条件 -->
        <TeCommonPriceParticipationconditions>
          <template #conditionList>
            <li class="mb-2">
              必要なメンタリング回数をこなすことが出来る
            </li>
            <li class="mb-2">
              期間内に必要な学習時間を確保出来る
            </li>
            <li class="mb-2">
              MacかWindowsのPCを持っている
            </li>
            <li class="mb-2">
              Macの場合：OS 12.0以上
            </li>
            <li class="mb-2">
              PCスペック：4GB以上のRAM、8GB以上を推奨
            </li>
            <li class="mb-2">
              Google Chrome を利用できる
            </li>
            <li class="mb-2">
              PCの基本的な操作が問題なくできる
            </li>
            <li>ビデオチャットが可能な通信環境</li>
          </template>
        </TeCommonPriceParticipationconditions>

        <div class="flex flex-col items-center lg:flex-row lg:items-start lg:gap-x-8">
          <!-- 注意事項 -->
          <TeCommonPricePrecautions>
            <template #preCautionsList>
              <li class="mb-2">
                支払い方法はクレジットカード払い（分割可能）、コンビニ決済、銀行振込、Amazon Pay、PayPayからお選びいただけます。
              </li>
              <li class="mb-2">
                クレジットカード払いは、Visa、Master、JCB、AMEX、Dinersに対応しています。
              </li>
              <li class="mb-2">
                カード分割払いご利用回数（3/5/6/10/12/15/18/20/24）
              </li>
              <li class="mb-2">
                Dinersは分割の支払いが利用できません。
              </li>
              <li class="mb-2">
                コンビニ決済は30万円を超える支払いにはご利用いただけません。
              </li>
              <li class="mb-2">
                50万円を超えるPayPay決済をご利用の際は、本人確認の認証が必要となります。
              </li>
              <li class="mb-2">
                請求書払いをご希望の場合はお申込後、専用のフォームからご申請ください。
              </li>
              <li class="mb-2">
                決済後、専用のフォームから領収書の発行が可能です。
              </li>
              <li class="mb-2">
                参加にはウェブカメラ、マイクが必要となります。
              </li>
              <li>12/28から1/3はメンターサポート休止期間です。受講期間がサポート休止期間にかかる場合、受講が最大7日間延長されます。</li>
            </template>
          </TeCommonPricePrecautions>
          <!-- キャンセルポリシー -->
          <TeCommonPriceCancelPolicy />
        </div>
      </div>
    </section>

    <TeCourseSakiwari
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
    >
      <template #annotation02>
        <li>※4週間・8週間プランは先割の対象外です。</li>
      </template>
    </TeCourseSakiwari>

    <TeCommonTomowari
      bg="#a4c639"
      title-bg="#839e2e"
    />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-third"
    /> -->

    <TeCommonCareerSupport />

    <TeCommonComparisonSchool :original-assignment="true" />

    <TeCourseMessage />

    <TeCourseAndroidFlow />

    <!-- 251202導線削除 -->
    <!-- <TeCourseAndroidFaQ /> -->

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCourseApply
      :course="course"
      :cohorts="cohorts"
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
      :current-promotion="currentPromotion"
      :course-name-path="courseNamePath"
      :entry-discount-time-limit="entryDiscountTimeLimit"
      :entry-campaign="entryCampaign"
    />

    <!-- 下部固定ボタン -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import { IndexServices } from '~/services/indexService'
import { scriptTag } from '~/utility/scriptTag'
import { getCohorts, getCurrentPromotion, getCourse } from '~/utility/fetchAPI'
import { getAdItem } from '~/utility/utility'

import TeCourseAndroidCover from '~/components/Te/TeCourse/Android/TeCourseAndroidCover.vue'
import TeCommonPagenav from '~/components/Te/TeCommon/Pagenav/TeCommonPagenav.vue'
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonBannerSettlement from '~/components/Te/TeCommon/Banner/TeCommonBannerSettlement/TeCommonBannerSettlement.vue'
import TeCommonBannerTimelimit from '~/components/Te/TeCommon/Banner/TeCommonBannerTimelimit/TeCommonBannerTimelimit.vue'
import TeCommonBannerCampaign from '~/components/Te/TeCommon/Banner/TeCommonBannerCampaign/TeCommonBannerCampaign.vue'
import TeCourseAbout from '~/components/Te/TeCourse/TeCourseAbout.vue'
import TeCourseAndroidTarget from '~/components/Te/TeCourse/Android/TeCourseAndroidTarget.vue'
import TeCommonDemographics from '~/components/Te/TeCommon/TeCommonDemographics/TeCommonDemographics.vue'
import TeCourseAndroidOutput from '~/components/Te/TeCourse/Android/TeCourseAndroidOutput.vue'
import TeCourseAndroidCurriculum from '~/components/Te/TeCourse/Android/TeCourseAndroidCurriculum.vue'
import TeCourseAndroidWork from '~/components/Te/TeCourse/Android/TeCourseAndroidWork.vue'
import TeCommonBannerFreeTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerFreeTrial/TeCommonBannerFreeTrial.vue'
import TeCommonMentorSupportMentoring from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportMentoring/TeCommonMentorSupportMentoring.vue'
import TeCommonMentorSupportChatSupport from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportChatSupport/TeCommonMentorSupportChatSupport.vue'
import TeCommonMentorSupportIssueReview from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportIssueReview/TeCommonMentorSupportIssueReview.vue'
import TeCommonMentorSupportAboutFlow from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportAboutFlow/TeCommonMentorSupportAboutFlow.vue'
import TeCommonMentorSupportMentor from '~/components/Te/TeCommon/MentorSupportMentor/TeCommonMentorSupportMentor.vue'
import TeCommonMentorSupportReason from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportReason/TeCommonMentorSupportReason.vue'
import TeCommonLearningCycle from '~/components/Te/TeCommon/TeCommonLearningCycle/TeCommonLearningCycle.vue'
import TeCommonSliderVoice from '~/components/Te/TeCommon/Slider/TeCommonSliderVoice/TeCommonSliderVoice.vue'
import TeCommonCampaign from '~/components/Te/TeCommon/TeCommonCampaign/TeCommonCampaign.vue'
import TeCommonPriceTimeLimit from '~/components/Te/TeCommon/Price/TeCommonPriceTimeLimit/TeCommonPriceTimeLimit.vue'
import TeCoursePriceTable from '~/components/Te/TeCourse/TeCoursePriceTable.vue'
import TeCoursePriceInstallments from '~/components/Te/TeCourse/TeCoursePriceInstallments.vue'
import TeCommonPriceParticipationconditions from '~/components/Te/TeCommon/Price/TeCommonPriceParticipationconditions/TeCommonPriceParticipationconditions.vue'
import TeCommonPricePrecautions from '~/components/Te/TeCommon/Price/TeCommonPricePrecautions/TeCommonPricePrecautions.vue'
import TeCommonPriceCancelPolicy from '~/components/Te/TeCommon/Price/TeCommonPriceCancelPolicy/TeCommonPriceCancelPolicy.vue'
import TeCourseSakiwari from '~/components/Te/TeCourse/TeCourseSakiwari.vue'
import TeCommonTomowari from '~/components/Te/TeCommon/Tomowari/TeCommonTomowari.vue'
import TeCommonCareerSupport from '~/components/Te/TeCommon/TeCommonCareerSupport/TeCommonCareerSupport.vue'
import TeCommonComparisonSchool from '~/components/Te/TeCommon/Comparison/TeCommonComparisonSchool/TeCommonComparisonSchool.vue'
import TeCourseMessage from '~/components/Te/TeCourse/TeCourseMessage.vue'
import TeCourseAndroidFlow from '~/components/Te/TeCourse/Android/TeCourseAndroidFlow.vue'
import TeCourseAndroidFaQ from '~/components/Te/TeCourse/Android/TeCourseAndroidFaQ.vue'
import TeCourseApply from '~/components/Te/TeCourse/TeCourseApply.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAndroid } from '@awesome.me/kit-65d95819ce/icons/classic/brands'

const options = {
  async setup() {
    const route = useRoute()
    const courseNamePath = route.path.split('/')[2]
    const course = ref<Object | null>(null)

    return {
      route,
      course,
      courseNamePath,
      faAndroid,
    }
  },
  oldHead() {
    const scriptTags = scriptTag({
      facebookPixelCode: true,
      criteoScript: true,
      criteoItem: {
        deviceSize: useNuxtApp().$deviceSize,
        item: this.course?.id,
      },
      remarketingTag: {
        ad_item_id: this.course?.id,
        ad_item_price: this.course ? getAdItem(this.course) : null,
      },
    })
    return {
      title: 'Kotlinを勉強・学習できるAndroidアプリ講座 | テックアカデミー',
      meta: [
        ...metaTags({
          description:
            '【テックアカデミー(TechAcademy)】選抜された現役エンジニアから学べるAndroidアプリ開発(Kotlin)の講座。受講者数No.1のオンラインプログラミングスクール。専属のパーソナルメンターがマンツーマンでサポート。転職サポートもあり。',
          twitterTitle: 'Androidアプリコース（Kotlin）',
          twitterDescription:
            'Androidアプリコース開発を選抜された現役エンジニアから自宅で学べる。パーソナルメンターがマンツーマンで学習サポート。',
          twitterImage: '/_nuxt/ogp/te/tecourse/og-image-android.jpg',
          ogTitle: 'Androidアプリコース（Kotlin）',
          ogDescription:
            'Androidアプリコース開発を選抜された現役エンジニアから自宅で学べる。パーソナルメンターがマンツーマンで学習サポート。',
          ogUrl: '/course/android',
          ogImage: '/_nuxt/ogp/te/tecourse/og-image-android.jpg',
        }),
      ],
      script: scriptTags.script,
      noscript: scriptTags.noscript,
    }
  },
  data() {
    return {
      cohorts: [],
      latestCohort: null,
      sakiwariCohorts: [],
      currentPromotion: null,
      screenName: '',
      entryDiscountTimeLimit: null,
      entrySettlementTimeLimit: null,
      entryPaymentUrl: null,
      entryCampaign: null,
    }
  },
  async mounted() {
    const {
      data: {
        entryDiscountTimeLimit,
        entrySettlementTimeLimit,
        entryPaymentUrl,
        entryCampaign,
      },
    } = await new IndexServices(this.$api).getTopTimeLimits()
    this.entryDiscountTimeLimit = entryDiscountTimeLimit
    this.entrySettlementTimeLimit = entrySettlementTimeLimit
    this.entryPaymentUrl = entryPaymentUrl
    this.entryCampaign = entryCampaign

    const queryConfig = {
      course_screen_name: this.courseNamePath,
      normal_opened: true,
    }
    getCohorts(this.$api, queryConfig).then((response) => {
      this.cohorts = response.data
      this.latestCohort = response.data[0]
    })
    getCohorts(this.$api, {
      course_screen_name: this.courseNamePath,
      sakiwari: true,
    }).then((response) => {
      this.sakiwariCohorts = response.data
    })
    getCurrentPromotion(this.$api).then((response) => {
      this.currentPromotion = response.data
    })
    this.course = (
      await getCourse(this.$api, this.courseNamePath, { include_pack: true })
    )?.data
  },
  computed: {
    deviceSize() {
      return
    },
    BannerNameForShowing() {
      if (this.entrySettlementTimeLimit) {
        return 'settlement'
      } else if (this.entryCampaign) {
        return 'campaign'
      } else if (this.entryDiscountTimeLimit) {
        return 'discount'
      } else {
        return null
      }
    },
    beginsAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.begins_at)
        : null
    },
    closesAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.closes_at)
        : null
    },
  },
  methods: {},
  components: {
    TeCourseAndroidCover,
    TeCommonPagenav,
    TeCommonBannerTimeLimitCpnCode,
    TeCommonBannerSettlement,
    TeCommonBannerTimelimit,
    TeCommonBannerCampaign,
    TeCourseAbout,
    TeCourseAndroidTarget,
    TeCommonDemographics,
    TeCourseAndroidOutput,
    TeCourseAndroidCurriculum,
    TeCourseAndroidWork,
    TeCommonBannerFreeTrial,
    TeCommonMentorSupportMentoring,
    TeCommonMentorSupportChatSupport,
    TeCommonMentorSupportIssueReview,
    TeCommonMentorSupportAboutFlow,
    TeCommonMentorSupportMentor,
    TeCommonMentorSupportReason,
    TeCommonLearningCycle,
    TeCommonSliderVoice,
    TeCommonCampaign,
    TeCommonPriceTimeLimit,
    TeCoursePriceTable,
    TeCoursePriceInstallments,
    TeCommonPriceParticipationconditions,
    TeCommonPricePrecautions,
    TeCommonPriceCancelPolicy,
    TeCourseSakiwari,
    TeCommonTomowari,
    TeCommonCareerSupport,
    TeCommonComparisonSchool,
    TeCourseMessage,
    TeCourseAndroidFlow,
    TeCourseAndroidFaQ,
    TeCourseApply,
    TeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
